import { Globe } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const EnvironmentIcon = createLucideIcon(Globe);
